<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span><b>Not Long for This World</b></span></p>
<p class="bk-subtitle"><span>An Aaron Gunner Mystery</span></p>
<p class="authorname"><span>Gar Anthony Haywood</span></p>
<p class="publisher"><img alt="logo" src="images/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?63895dd9